// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { navy } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { MetricsClickable } from '@zocdoc/frontend-metrics';

const DoctorName = ({ className, provider = {}, style }) => {
    const { firstName, lastName, postnominal, prenominal } = provider;

    return (
        <MetricsClickable
            action="Click LightweightDoctorCard Name"
            element="DoctorCardInfoName"
        >
            <DoctorNameText
                className={className}
                data-test="lightweight-doctor-card-info-name"
                style={style}
            >
                {prenominal ? (
                    <SpanNoWrap
                        data-test="lightweight-doctor-card-info-name-prefix"
                        itemProp="honorificPrefix"
                    >
                        {prenominal}{' '}
                    </SpanNoWrap>
                ) : null}
                <span
                    data-test="lightweight-doctor-card-info-name-full"
                    itemProp="name"
                >
                    {firstName} {lastName}
                </span>
                {postnominal ? (
                    <SpanNoWrap>
                        ,{' '}
                        <span
                            data-test="lightweight-doctor-card-info-name-suffix"
                            itemProp="honorificSuffix"
                        >
                            {postnominal}
                        </span>
                    </SpanNoWrap>
                ) : null}
            </DoctorNameText>
        </MetricsClickable>
    );
};

// Create dotted underline using background-image to allow proper stylings
// when the name overflows to two lines
const DoctorNameText = styled.span`
    box-sizing: border-box;
    color: ${navy};
    cursor: pointer;
    font: 16px/20px ${FontFamily.SharpSansBold};
    background-position: 0px 1.1em;
    background-repeat: repeat-x;
    background-size: 2px 1px;
    padding-bottom: 3px;

    &:hover {
        background-image: linear-gradient(to right, #000000 50%, #000000 50%);
    }

    ${breakpoint.medium} {
        font-size: 20px;
        line-height: 23px;
    }
`;

const SpanNoWrap = styled.span`
    white-space: nowrap;
`;

export default DoctorName;
